import React from 'react';
import { ArrowPathIcon, DocumentChartBarIcon } from '@heroicons/react/24/outline';
import './form-modal.css';

/** Checkbox row with an icon, a title and a short explanation. */
export function FormOption({ checked, onToggle, disabled, Icon, title, children }) {
  return (
    <label className="event-modal-option">
      <input type="checkbox" checked={checked} onChange={onToggle} disabled={disabled} />
      <div>
        <div className="event-modal-option-head">
          <Icon />
          <strong>{title}</strong>
        </div>
        <p>{children}</p>
      </div>
    </label>
  );
}

export function FormOptionList({ title, children }) {
  return (
    <div className="event-modal-section">
      <span className="event-modal-section-title">{title}</span>
      <div className="event-modal-option-list">{children}</div>
    </div>
  );
}

/** Labelled control (`children`) with an optional hint under it. */
export function FormField({ id, label, hint, children }) {
  return (
    <label className="event-modal-field" htmlFor={id}>
      <span>{label}</span>
      {children}
      {hint && <small>{hint}</small>}
    </label>
  );
}

export function FormIntro({ title, children }) {
  return (
    <div className="event-modal-intro">
      <strong>{title}</strong>
      <span>{children}</span>
    </div>
  );
}

export function FormError({ message }) {
  return message ? <div className="event-modal-error">{message}</div> : null;
}

/** Submit button content for a generation form: the label, or a spinner while starting. */
export function GenerateLabel({ starting, label }) {
  return starting ? (
    <>
      <ArrowPathIcon className="event-modal-spin" />
      Starting...
    </>
  ) : (
    <>
      <DocumentChartBarIcon />
      {label}
    </>
  );
}

/** Cancel and submit buttons; `children` is the submit button content. */
export function FormActions({ onCancel, disabled, children }) {
  return (
    <div className="event-modal-actions">
      <button type="button" onClick={onCancel} className="event-modal-btn" disabled={disabled}>
        Cancel
      </button>
      <button type="submit" className="event-modal-btn event-modal-btn-primary" disabled={disabled}>
        {children}
      </button>
    </div>
  );
}
